import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TWorkspace } from 'src/app/project/modules/workspace/workspace.model';
import { TSelectedCustomFields } from '../../add-custom-field.model';

@Component({
    selector: 'pp-add-custom-field-import-select-all',
    templateUrl: './add-custom-field-import-select-all.component.html',
    styleUrls: ['./add-custom-field-import-select-all.component.scss'],
    standalone: false
})
export class AddCustomFieldImportSelectAllComponent {
  @Input() ppSite: TWorkspace;
  @Input() ppNumberOfSelectableFields: number;
  @Input() ppSelectedCustomFields: TSelectedCustomFields;
  @Output() ppSelectAll = new EventEmitter();
  @Output() ppDeselectAll = new EventEmitter();

  constructor() {}

  selectAll(): void {
    this.ppSelectAll.emit();
  }

  deselectAll(): void {
    this.ppDeselectAll.emit();
  }
}
